import { render } from "./AuctionHouses.vue?vue&type=template&id=53535182&scoped=true"
import script from "./AuctionHouses.vue?vue&type=script&lang=js"
export * from "./AuctionHouses.vue?vue&type=script&lang=js"

import "./AuctionHouses.vue?vue&type=style&index=0&id=53535182&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53535182"]])

export default __exports__